import axios from 'axios'
import library from '../../../utils/Library'

export const updateGlobalNotificationEAuthz = async (body) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL =
    library.getBaseAPIUrl('global_notification') +
    '/updateGlobalNotificationEAuthz'

  return await axios({
    url: URL,
    method: 'PATCH',
    data: body,
    headers: {
      Authorization: `Bearer ${TOKEN}`
    }
  })
}
